import { MDSErrorBoundary } from "@/mds/components/mds-error-boundary";

export const SessionItemErrorBoundary: React.FC<{
  children: React.ReactNode;
  itemId: string;
}> = ({ children, itemId }) => {
  return (
    <MDSErrorBoundary
      boundaryId={itemId}
      errorMessage="Error showing message."
      retryText="Retry?"
      logPrefix="[MDSSession] Error boundary"
      errorMessageStyle={{ marginLeft: "30px" }}
    >
      {children}
    </MDSErrorBoundary>
  );
};
